module.exports = require("@popperjs/core");